import React, { Fragment } from 'react'
import {Grid, Icon, Typography, CardContent, Card, CardHeader } from '@material-ui/core';

import ModalTravelInformation from '../../ResultsPagePasses/partials/ModalTravelInformation';
import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';

//import IconC from './../../../components/_IconC'

export default function ProductDetailPasses(props) {
    const searchInfo = props.bookingItems[0]

    return (
        <Card className="product-detail card">
            <CardHeader className="product-detail-header head-resume"
                avatar={<Icon>train</Icon>}
                title={searchInfo.label}
            />
            <CardContent>
                    <div >
                        <Typography className="tramo-title" variant="body1" component="h4"></Typography>
                        <Fragment>                           
                            <Grid container spacing={1} className="mb-05">
                                <Grid item xs={6}>
                                    <Typography className="label-resume">DESTINO:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}><Icon className="icon">place</Icon>  {searchInfo.descriptionCode.description}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="label-resume">CLASE:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}><Icon className="icon">star</Icon>  {searchInfo.travelClass.comfortCategory.label}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="label-resume">FECHA:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}><Icon className="icon">event</Icon>  {moment(searchInfo.validityStartDate).locale('es').format('dddd, Do MMM YY').replace('º','')}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="label-resume">DÍAS:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}><Icon className="icon">event</Icon>  {searchInfo.numberOfTravelDays}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="label-resume">VÁLIDO DESDE:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}><Icon className="icon">event</Icon> {moment(searchInfo.activationPeriod.startDate).locale('es').format('dddd, Do MMM YY').replace('º','')}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="label-resume">VÁLIDO HASTA:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}><Icon className="icon">event</Icon> {moment(searchInfo.activationPeriod.endDate).locale('es').format('dddd, Do MMM YY').replace('º','')}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className="label-resume">TIPO:</Typography>
                                    <Typography className="detail-item">
                                        <span style={{textTransform: 'capitalize'}}>  {searchInfo.periodType.description}</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Fragment>

                        <ModalTravelInformation
                            conditions={searchInfo.conditions}
                            title={searchInfo.label}
                            type={"condiciones"}
                            ages={props.ages}
                            page={props.page}
                        />               
                    </div>
            </CardContent>
        </Card>
    )
}
